import $api from "@/api/index";

interface CreateAuthSessionResponse {
  session_id: string;
  expires_at: number;
}

interface CheckAuthSessionResponse {
  status: "pending" | "approved" | "expired";
  approved: boolean;
  token: string | null;
  telegram_id: number | null;
}

interface PhoneAuthResponse {
  token: string;
  telegram_id: number;
  phone: string;
}

export async function createAuthSession() {
  const { data } = await $api.post<CreateAuthSessionResponse>(
    "/v2/system/auth/session"
  );
  return data;
}

export async function checkAuthSession(sessionId: string) {
  const { data } = await $api.get<CheckAuthSessionResponse>(
    "/v2/system/auth/check-session",
    {
      params: { session_id: sessionId },
    }
  );
  return data;
}

export async function authenticateByPhone(phone: string) {
  const { data } = await $api.post<PhoneAuthResponse>("/v2/system/auth/phone", {
    phone,
  });
  return data;
}
